import { computed } from "vue";

import { useMetadataStore } from "@/stores/metadata-store";

import type { Metadata } from "@/models/Metadata";

export function useDirectlyRelatedFiles(file: Metadata) {
  const metadataStore = useMetadataStore();

  function groupFiles(acc: Record<"siblings" | "children", Metadata[]>, cur: Metadata) {
    if (cur.parent == null || cur.fileReference === file.fileReference) {
      return acc;
    }

    if (cur.parent === file.fileReference) {
      return { ...acc, children: [...acc.children, cur] };
    }

    if (cur.parent === file.parent) {
      return { ...acc, siblings: [...acc.siblings, cur] };
    }

    return acc;
  }

  const relatedFiles = computed(() => {
    return {
      filteredFiles: metadataStore.filteredFiles
        .filter((f) => file.folder === f.folder)
        .reduce<Record<"siblings" | "children", Metadata[]>>(groupFiles, {
          siblings: [],
          children: [],
        }),
      unfilteredFiles: metadataStore.requestedFiles.reduce<Record<"siblings" | "children", Metadata[]>>(groupFiles, {
        siblings: [],
        children: [],
      }),
    };
  });

  return relatedFiles;
}
